export default __webpack_public_path__ + "static/media/about3.dcf547d7.png";